module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/de2d975f826e11936100c21fed2dc24a.png";